import ImageConverterTemplate from "../components/ImageConverterTemplate";

export default function ConvertTiffToWebp() {
  return (
    <ImageConverterTemplate
      sourceFormat="TIFF"
      targetFormat="WebP"
      acceptTypes=".tiff,.tif,image/tiff"
      slug="convert-tiff-to-webp"
      gradientColors="from-purple-500 to-green-500"
      accentColor="green"
      showQualitySlider={true}
    />
  );
}
